// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { apexTestnet as _apexTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the apexTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3993
 * Chain Name: APEX Testnet
 * Default Block Explorer: https://exp-testnet.apexlayer.xyz
 * Default RPC URL: https://rpc-testnet.apexlayer.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { apexTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: apexTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const apexTestnet = createCommon({
	..._apexTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
